export class DateUtil {

  /**
   * è·åå½å¹´çåæ¦æ¥
   */
  static getNewYear(date: Date = new Date()): Date {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  /**
   * è®¾ç½®æ¶é´ç¹ä¸º24ç¹
   */
  static getEndDay(date: Date = new Date()): Date {
    date.setHours(23, 59, 59, 999);
    return date;
  }

  /**
   * è®¾ç½®æ¶é´ç¹ä¸º0ç¹
   */
  static getStartDay(date: Date = new Date()): Date {
    date.setHours(0, 0, 0, 0);
    return date;
  }

  /**
   * è·åå½å¹´çæåä¸å¤©
   */
  static getLastDay(date: Date = new Date()): Date {
    date.setMonth(11, 31);
    date.setHours(0, 0, 0, 0);
    return date;
  }

}
